import { RunIcon } from './RunIcon';

/**
 * author: Google
 * id 2A869029-60EB-4965-9BE4-9B3DB964C707
 * name run
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/run.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanRunIcon = RunIcon;
export default HumanRunIcon